<template>
  <div class="bar-box">
    <div class="bar-info">
      {{ willMemberShipText }}
      <span class="rule" @click="openJoinRules">{{ $t('FoodC_subscription_VPMP_seXT') }}</span>
    </div>
  </div>
</template>

<script>
import { openJoinRules } from '@/page/member/common/utils.js'
import { CYCLE_TYPE } from '../common/enumsUtil.js'
import mixin from '@/page/member/mixins.js'

export default {
  mixins: [mixin],
  props: {
    membership: {
      default: () => {},
      type: Object,
    },
  },
  computed: {
    willEnableList() {
      return this.willLongTerm[0] || {}
    },
    willMemberShipText() {
      let text = ''
      const dynamicContent = {
        date1: this.membership.expireDate,
        date2: this.willEnableList.enableDate,
        date3: this.willEnableList.renewDate,
        money: this.willEnableList.renewPriceSplit?.display,
      }
      switch (this.willEnableList?.cycleType) {
        case CYCLE_TYPE.quarter:
          text = this.$t('FoodC_membership_yQRX_Opwv', dynamicContent)
          break
        case CYCLE_TYPE.halfYear:
          text = this.$t('FoodC_membership_StFc_NVHY', dynamicContent)
          break
        case CYCLE_TYPE.year:
          text = this.$t('FoodC_membership_tatd_NykT', dynamicContent)
          break
      }
      return text
    },
  },
  methods: {
    openJoinRules,
  },
}
</script>

<style lang="scss" scoped>
.bar-box {
  margin: 20px;
  padding: 32px;
  background-color: #fff;
  border-radius: 40px;
  .bar-info {
    font-family: DiDiSans-Pro-Regular;
    font-size: 28px;
    color: #0b0b0d;
    letter-spacing: 0;
    line-height: 40px;
    font-weight: 400;
    .rule {
      text-decoration: underline;
      font-family: DiDiSans-Pro-Bold;
      font-size: 28px;
      color: #0b0b0d;
      letter-spacing: 0;
      line-height: 40px;
      font-weight: 700;
    }
  }
}
</style>
